import React, { memo } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {Box, IconButton, Tooltip} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ClipCard from "../clipCard";
import CloseIcon from '@mui/icons-material/Close';
import {CollectionClip} from "../../../types/collectionTypes";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import {useSelectedCard} from "@/contexts/SelectedCardContext";
import { circularIconHoverSx } from "@/styles/iconHover";

interface SortableWipeCardProps {
    id: string;
    card: CollectionClip;
    onRemoveClick?: () => void;
    onLockClick?: () => void;
    hasWarning?: boolean
    sortable?: boolean
}

/* ---------------- MEMOIZED CLIP CARD ---------------- */
const MemoClipCard = memo(function MemoClipCard({ card, hasWarning, sortable = false }: { card: CollectionClip, hasWarning?: boolean, sortable?: boolean }) {
  return (
    <ClipCard
      collectionId=""
      card={card}
      editFlag={false}
      pinned={false}
      infoIconFlag={true}
      hasWarning={hasWarning}
      smaller={true}
      sortable={sortable}
    />
  );
});

export default function SortableWipeCard({ id, card, hasWarning, onRemoveClick = () => {}, onLockClick = () => {} }: SortableWipeCardProps) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const { lockedKeyMoments } = useSelectedCard()

    return (
        <Box
            ref={setNodeRef}
            {...attributes}
            sx={{
                transform: CSS.Transform.toString(transform),
                transition,
                opacity: isDragging ? 0.7 : 1,
                position: "relative",
            }}
        >

            {/* DRAG HANDLE: SOLO QUI i listeners */}
            <Box sx={{
                position: "absolute",
                display: "flex",
                gap: 1,
                top: 6,
                right: 20,
                zIndex: 50,
            }}>
                <Tooltip
                    title={!lockedKeyMoments[card.id] ? "Press to lock" : "Mandatory, press to unlock’ "}
                    arrow
                    placement="top"
                >
                    <IconButton
                        size="small"
                        sx={circularIconHoverSx({ bg: 'rgba(0,0,0,0.45)', hoverBg: 'rgba(0,0,0,0.65)' })}
                        onClick={onLockClick}
                    >
                        {!lockedKeyMoments[card.id] ? (
                            <LockOpenOutlinedIcon fontSize="small" sx={{ color: "white" }} />
                        ) : (
                            <LockOutlinedIcon fontSize="small" sx={{ color: "white" }} />
                        )}
                    </IconButton>
                </Tooltip>
                <Tooltip
                    title={"Hold to reorder key moment"}
                    arrow
                    placement="top"
                >
                    <IconButton
                        {...listeners}
                        size="small"
                        sx={circularIconHoverSx({ bg: 'rgba(0,0,0,0.45)', hoverBg: 'rgba(0,0,0,0.65)' })}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <DragIndicatorIcon fontSize="small" sx={{ color: "white" }} />
                    </IconButton>
                </Tooltip>

            </Box>

            {!lockedKeyMoments[card.id] &&
                <Tooltip title={"Remove key moment from selection"}>
                    <IconButton
                        size="small"
                        sx={{
                            position: "absolute",
                            top: 6,
                            left: 6,
                            zIndex: 50,
                            ...circularIconHoverSx({ bg: 'rgba(0,0,0,0.45)', hoverBg: 'rgba(0,0,0,0.65)' }),
                        }}
                        onClick={onRemoveClick}
                    >
                        <CloseIcon fontSize="small" sx={{ color: "white" }} />
                    </IconButton>
                </Tooltip>
                }

            {/* Card: ora click/controlli funzionano */}
            <MemoClipCard card={card} hasWarning={hasWarning} sortable={true} />
        </Box>
    );
}